import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, Phone, MessageCircle } from "lucide-react";
import { Sheet, SheetContent, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import { Logo } from "@/components/Logo";
import { QuoteButton } from "@/components/QuoteDialog";
import { waLink } from "@/lib/api";

export const NAV = [
  { to: "/", label: "Inicio", id: "home" },
  { to: "/servicios", label: "Servicios", id: "services" },
  { to: "/nosotros", label: "Nosotros", id: "about" },
  { to: "/citas", label: "Citas", id: "appointments" },
  { to: "/opiniones", label: "Opiniones", id: "reviews" },
  { to: "/galeria", label: "Galería", id: "gallery" },
  { to: "/testimonios", label: "Testimonios", id: "testimonials" },
  { to: "/contacto", label: "Contacto", id: "contact" },
];

const linkCls = ({ isActive }) =>
  `relative py-1 text-sm font-semibold transition-colors ${isActive ? "text-green after:absolute after:-bottom-1 after:left-0 after:h-0.5 after:w-full after:bg-gold" : "text-ink2 hover:text-green"}`;

const btn = { color: "white", borderRadius: "8px", textDecoration: "none", fontWeight: "bold", whiteSpace: "nowrap" };

const HeaderWhatsApp = () => (
  <a href="https://wa.me/529991919300" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp" data-testid="header-whatsapp-btn"
    className="shrink-0 px-3 py-2 text-sm sm:px-3.5" style={{ ...btn, background: "#25D366" }}>
    📱<span className="hidden sm:inline"> WhatsApp</span>
  </a>
);

export const Header = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-40 backdrop-blur-xl bg-white/90 border-b border-line">
      <div className="mx-auto flex h-20 max-w-[1760px] items-center justify-between gap-4 px-4 sm:px-6 lg:px-8">
        <div className="flex items-center gap-3 sm:gap-5">
          <Link to="/" aria-label="Inicio" className="shrink-0 whitespace-nowrap" data-testid="header-logo-link"><Logo /></Link>
        </div>
        <nav aria-label="Principal" className="hidden xl:flex shrink-0 items-center gap-5">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end className={linkCls} data-testid={`nav-${n.id}-link`}>{n.label}</NavLink>
          ))}
        </nav>
        <div className="hidden xl:flex shrink-0 items-center gap-3">
          <a href="tel:+529991919300" className="hidden" data-testid="header-phone-link">
            <Phone size={16} className="text-brand" /> 999-191-9300
          </a>
          <QuoteButton className="btn-ghost !py-2.5 whitespace-nowrap" testId="header-quote-btn" />
          <a href={waLink("529991919300", "Hola, quiero agendar una revisión.")} target="_blank" rel="noopener noreferrer" className="btn-gold !py-2.5" data-testid="header-book-btn"><MessageCircle size={16} /> <span className="whitespace-nowrap">Agenda por WhatsApp</span></a>
        </div>
        <div className="flex shrink-0 items-center gap-2">
        <HeaderWhatsApp />
        <Sheet open={open} onOpenChange={setOpen}>
          <SheetTrigger className="xl:hidden p-2 text-green" aria-label="Abrir menú" data-testid="mobile-menu-btn"><Menu /></SheetTrigger>
          <SheetContent side="right" className="bg-white border-line w-[85vw] max-w-sm">
            <SheetTitle className="sr-only">Menú</SheetTitle>
            <nav aria-label="Móvil" className="mt-10 flex flex-col gap-6">
              {NAV.map((n) => (
                <NavLink key={n.to} to={n.to} end onClick={() => setOpen(false)} className={linkCls} data-testid={`mobile-nav-${n.id}-link`}>
                  <span className="text-xl">{n.label}</span>
                </NavLink>
              ))}
              <Link to="/citas" onClick={() => setOpen(false)} className="btn-gold mt-4" data-testid="mobile-book-btn">Agendar cita</Link>
              <QuoteButton className="btn-ghost" testId="mobile-quote-btn" />
              <a href="tel:+529991919300" className="btn-ghost">Llamar 999-191-9300</a>
            </nav>
          </SheetContent>
        </Sheet>
        </div>
      </div>
    </header>
  );
};
